export default "__VITE_ASSET__BqHbFMEH__"